import LiveUpdatesDisabledBanner from 'components/LiveUpdatesDisabledBanner'
import ProtectedPageHeader from 'components/ProtectedPageHeader'
import { LIVE_UPDATES_PATH } from 'constants/liveUpdates'
import { useCanOpenLiveUpdates } from 'hooks/useCanOpenLiveUpdates'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import { useLiveUpdatesState } from 'hooks/useLiveUpdatesState'
import { useReportPermission } from 'hooks/useReportPermission'
import { buildTranslate } from 'locales'
import React from 'react'
import { Container } from 'react-bootstrap-five'
import LookerFooter from 'scenes/LookerEmbed/components/LookerFooter'
import LookerIframe from 'scenes/LookerEmbed/LookerIframe'
import OrderRatingsDisabledCard from './OrderRatingsDisabledCard'

const t = buildTranslate('order_ratings')
const liveUpdatesT = buildTranslate('live_updates')

// This page's Looker report lives at its own route, /order_ratings, keeping
// the SAME permission gate the old combined page's Overview tab used —
// LocationReports (RBAC) / NpsReports (legacy). The inbox half (DetailsPane,
// RatingDetail, and their data hooks) lives on the Order feedback page at
// /order_feedback; see that scene's index.tsx.
const OVERVIEW_DASHBOARD = 'dashboards/536'
const OVERVIEW_HEIGHT_PX = 1750
// Extra min-height below the iframe so the Looker footer + page padding aren't clipped.
const OVERVIEW_FOOTER_SLACK_PX = 300
const OVERVIEW_MIN_HEIGHT_PX = OVERVIEW_HEIGHT_PX + OVERVIEW_FOOTER_SLACK_PX

const OrderRatingsReport = () => {
  const merchant = useCurrentMerchant()
  const liveUpdatesState = useLiveUpdatesState()
  const canOpenLiveUpdates = useCanOpenLiveUpdates()
  const permission = useReportPermission({
    rbac: 'LocationReports',
    legacy: 'NpsReports',
  })

  if (!merchant) return null

  return (
    <ProtectedPageHeader
      title={t('header.title')}
      description={t('header.description')}
      resource={permission.resource}
      action={permission.action}
    >
      {liveUpdatesState.isDisabled && (
        <Container
          className="px-0 mb-l"
          data-testid="order-ratings-disabled-banner"
        >
          <LiveUpdatesDisabledBanner
            lead={liveUpdatesT('disabled_banner.order_ratings.lead')}
            body={liveUpdatesT('disabled_banner.order_ratings.body')}
            resumeText={liveUpdatesT('disabled_banner.order_ratings.resume')}
            resume={
              canOpenLiveUpdates
                ? { kind: 'link', to: LIVE_UPDATES_PATH }
                : undefined
            }
          />
        </Container>
      )}
      {liveUpdatesState.isDisabled ? (
        <Container className="px-0 mb-xl">
          <OrderRatingsDisabledCard />
        </Container>
      ) : (
        <Container
          className="px-0"
          style={{ minHeight: `${OVERVIEW_MIN_HEIGHT_PX}px` }}
        >
          <LookerIframe
            path={OVERVIEW_DASHBOARD}
            merchant={merchant}
            height={`${OVERVIEW_HEIGHT_PX}px`}
          />
          <LookerFooter className="my-xl" />
        </Container>
      )}
    </ProtectedPageHeader>
  )
}

export default OrderRatingsReport
